import React from 'react';
import { forEach, isString, uniqueId } from 'lodash';
import Draggable from 'react-draggable';

class ResizableHorizontalLayout extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      // percent width strings ("20%") or absolute width numeric values (480)
      sizes: props.initialSizes || ['60%', '40%'],
    };

    this._id = uniqueId('resizable-horizontal-layout-');
  }

  render() {
    const { minSizes, children } = this.props;
    const { sizes } = this.state;
    // Filter out falsy children (null, false, undefined) to handle conditionals
    const validChildren = React.Children.toArray(children).filter(Boolean);
    const lastIndex = validChildren.length - 1;
    const elements = [];

    forEach(validChildren, (child, index) => {
      const size = sizes[index];
      const elementId = this._getElementId(index);

      elements.push(
        React.cloneElement(child, {
          key: elementId,
          id: elementId,
          style: {
            ...child.props.style,
            width: size,
          },
        }),
      );

      if (index < lastIndex) {
        const nextElementId = this._getElementId(index + 1);
        const element = document.getElementById(elementId);
        const nextElement = document.getElementById(nextElementId);
        let minX = 0;
        let maxX = 0;

        if (element && nextElement) {
          const nextSize = sizes[index + 1];
          const minSize = minSizes[index];
          const nextMinSize = minSizes[index + 1];
          const maxSize = this.props.maxSizes ? this.props.maxSizes[index] : null;
          const elementWidth = isString(size) ? element.offsetWidth : size;
          const nextElementWidth = isString(nextSize) ? nextElement.offsetWidth : nextSize;
          minX = minSize - elementWidth;
          maxX = maxSize ? maxSize - elementWidth : nextElementWidth - nextMinSize;
        }

        elements.push(
          <div
            key={`resize-handle-${index}`}
            aria-label="resizable-cursor"
            style={{ position: 'relative' }}
          >
            <div className="section-resize-handle-x" />
            <Draggable
              axis="x"
              defaultClassName="section-resize-handle-x"
              defaultClassNameDragging="section-resize-handle-x-active"
              bounds={{ left: minX, right: maxX }}
              position={{ x: 0, y: 0 }}
              onStop={(event, data) => this._onDragStop(event, data, index)}
            >
              <div />
            </Draggable>
          </div>,
        );
      }
    });

    return (
      <div id={this._id} className="resizable-horizontal-layout">
        {elements}
      </div>
    );
  }

  _getElementId = (index) => {
    return `${this._id}-element-${index}`;
  };

  _onDragStop = (event, data, index) => {
    const { sizes } = this.state;
    const elementId = this._getElementId(index);
    const nextElementId = this._getElementId(index + 1);
    const element = document.getElementById(elementId);
    const nextElement = document.getElementById(nextElementId);

    if (element && nextElement) {
      const newSizes = [...sizes];
      const size = sizes[index];
      const nextSize = sizes[index + 1];
      const elementWidth = isString(size) ? element.offsetWidth : size;
      const nextElementWidth = isString(nextSize) ? nextElement.offsetWidth : nextSize;
      newSizes[index] = elementWidth + data.x;
      newSizes[index + 1] = nextElementWidth - data.x;

      this.setState({ sizes: newSizes });
    }
  };
}

export default ResizableHorizontalLayout;
